export const getRandomInt = ({
    min = 0,
    max = 9,
    power10 = 0,
    hasNegative = true,
} = {}) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    let result = Math.floor(Math.random() * (max - min + 1)) + min;

    if (power10) {
        result *= 10 * power10;
    }

    if (hasNegative) {
        result *= Math.round(Math.random()) ? 1 : -1;
    }

    return result;
};

export const stringToNumber = (n) => {
    const result = parseInt(n);
    if (isNaN(result)) {
        return 0;
    }
    return result;
};
